import { map, concat, orderBy, uniq, find } from 'lodash'
import { imprintsFormatter } from './imprints';
import { artistsFormatter } from './artists';
import { projectsFormatter } from './projects';
import { productsFormatter } from './products';
import { tracksFormatter } from './tracks';

const inputSeparator = new RegExp('[,\t]+');
const batchInputSeparator = new RegExp('[ ,\t\n]+');
const batchSeparator = '\n';
const patterns = [/[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/ig, /[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}/g, /([0-9]){11,16}/g];


export const searchFormatter = {
    formatAutocomplete,
    formatImportSearch,
    formatImport
};

function _formatAutocomplete(data) {
    let {hits, total}= data.hits;
    return hits.map(hit=>{
        switch(hit._type) {
        case 'imprint':
            return imprintsFormatter.formatAutocompleteItem(hit);
        case 'artist':
            return artistsFormatter.formatAutocompleteItem(hit);
        case 'product':
            return productsFormatter.formatAutocompleteItem(hit);
        case 'track':
            return tracksFormatter.formatAutocompleteItem(hit);
        }
    });
}

function formatAutocomplete(data, entities) {
    let results = {imprints: [], artists: [], projects: [], products: [], tracks: [], total: 0};
    for(let entity of entities) {
        if(data[entity]) {
            for(let entry of data[entity]) {
                const origEntry = Object.assign({}, entry);
                let weight = 1;
                switch(entity) {
                    case 'imprints':
                        entry = imprintsFormatter.formatAutocompleteItem(entry);
                        break;
                    case 'artists':
                        entry = artistsFormatter.formatAutocompleteItem(entry);
                        weight = 1.2;
                        break;
					case 'projects':
						entry = projectsFormatter.formatAutocompleteItem(entry);
						weight = 1.1;
						break;						
                    case 'products':
                        entry = productsFormatter.formatAutocompleteItem(entry);
                        weight = 1.1;
                        break;
                    case 'tracks':
                        entry = tracksFormatter.formatAutocompleteItem(entry);
                        break;
                }
                entry.rank = weight*origEntry.pg_search_rank;
                results[entity].push(entry);
                results.total ++;
            }
        }
    }
    for(let entity of Object.keys(results)) {
        if(Array.isArray(results[entity]))
            results[entity] = orderBy(results[entity], ['rank'], ['desc']);
    }
	/*
    if(entities.includes('projects')) {
    	const products = data.products;
    	const projectKeys = uniq(map(products, 'project'));
    	results.projects = [];
    	for(let projectKey of projectKeys) {
    		const productsInProject = products.filter(product=>product.project == projectKey);
    		let project = productsInProject.reduce((prev, curr)=>{
    			if(!prev.hasOwnProperty('cat_no'))
    				return curr;
    			else 
    				return curr.cat_no.length < prev.cat_no.length ? curr : prev;
    		}, {});
    		const origProject = Object.assign({}, project);
    		project = projectsFormatter.formatAutocompleteItem(project);
    		project.rank = origProject.pg_search_rank;
    		results.projects.push(project);
    		results.total ++;
    	}
    	
    }
	*/
    return results;
}

function formatImportSearch(query){
    const queryParts = query.split(batchSeparator).map(row=>row.trim());
    return queryParts.filter(row=>row).join(batchSeparator);
}

function formatImport(searchResults, entities, querySearch) {

    let results = [];
    let importIndex = 0;
    const querySearchArray = querySearch.split(batchSeparator);
    for(let searchResultIndex in searchResults) {
        let {exact_match, result} = searchResults[searchResultIndex];
        let formattedResults = [];
        for(let entity of entities) {
            if(result[entity]) {
                for(let entry of result[entity]) {
                    const origEntry = Object.assign({}, entry);
                    let weight = 1;
                    switch(entity) {
                        case 'imprints':
                            entry = imprintsFormatter.formatAutocompleteItem(entry);
                            break;
                        case 'artists':
                            entry = artistsFormatter.formatAutocompleteItem(entry);
                            weight = 1.2;
                            break;
                        case 'products':
                            entry = productsFormatter.formatAutocompleteItem(entry);
                            weight = 1.1;
                            break;
                        case 'projects':
                            entry = projectsFormatter.formatAutocompleteItem(entry);
                            weight = 1.1;
                            break;                            
                        case 'tracks':
                            entry = tracksFormatter.formatAutocompleteItem(entry);
                            if(entry.code && entry.code.match(/^\d+$/))
                                continue;
                            break;
                    }
                    entry.rank = weight*origEntry.pg_search_rank;
                    entry.query = querySearchArray[searchResultIndex];
                    entry.raw = origEntry
                    formattedResults.push(entry);
                }
            }
        }
        if(!formattedResults.length)
            exact_match = false;
        
        if(!exact_match || formattedResults.length > 1) {
            formattedResults.unshift({
                id: null,
                entity: null,
                name: '(skip import)',
                name_raw: '(skip import)',
                rank: 1
            })
        }
        results.push({exactMatch: exact_match, query: querySearchArray[searchResultIndex], result: formattedResults, importIndex, multipleMatches: (exact_match ? (formattedResults.length) : 0)});
        importIndex++;
    }
    return results;
}